import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import PlayerCardHolder from './PlayerCardHolder';
import DraggablePlayerCard from './DraggablePlayerCard';
import { useSquad } from '../contexts/SquadContext';

function DroppablePlayerCardHolder({ order, position }) {

  const { playerInfos } = useSquad()
  
  const { isOver, setNodeRef } = useDroppable({
    id: `slot-${order}`,
    data: { 
      type: 'LineupSlot', 
      order: order, 
    }
  });

  const isOverStyle = isOver ? {
    backgroundColor: '#e6f7ff', 
    outline: '1px dashed #316BFF ',
    borderRadius: '0px', 
    opacity: 0.9,
  } : {};

  return (
    <div 
      ref={setNodeRef} 
      style={{ ...isOverStyle }}
    >
      {playerInfos[position] ? <DraggablePlayerCard
          key={order}
          player={playerInfos[position]}
          isInSlot={true} // 이 카드는 슬롯 안에 있음을 명시
          order={order}
          position={position}
      />
      :
      <PlayerCardHolder 
        position={order} 
        isForDisplay={true}
      /> }
    </div>
  );
}

export default DroppablePlayerCardHolder;